export function getEntitlementsCount(entitlementsCount?: number, permissionsCount?: number) {
  return `${entitlementsCount}${
    permissionsCount && entitlementsCount !== permissionsCount ? `/${permissionsCount}` : ''
  } Entitlements`;
}
